/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface TOTPMethodOptions
 */
export interface TOTPMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof TOTPMethodOptions
     */
    method: FactorMethod;
}

/**
 * Check if a given object implements the TOTPMethodOptions interface.
 */
export function instanceOfTOTPMethodOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "method" in value;

    return isInstance;
}

export function TOTPMethodOptionsFromJSON(json: any): TOTPMethodOptions {
    return TOTPMethodOptionsFromJSONTyped(json, false);
}

export function TOTPMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPMethodOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
    };
}

export function TOTPMethodOptionsToJSON(value?: TOTPMethodOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'method': FactorMethodToJSON(value.method),
    };
}

